import script from "./LayoutIndex.vue?vue&type=script&lang=ts&setup=true&name=layout-index"
export * from "./LayoutIndex.vue?vue&type=script&lang=ts&setup=true&name=layout-index"

import "./LayoutIndex.vue?vue&type=style&index=0&id=51418c1c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51418c1c"]])

export default __exports__